import axios from 'axios';

export const DOCUMENT_TYPES = {
  TAX_NUMBER: 0,
  ID: 1,
  PASSAPORT: 2,
}

export async function getDriverInfo(docNumber, documentType = DOCUMENT_TYPES.ID) {
  return (await axios.get(`/driver-info/${docNumber}?documentType=${documentType}`)).data
}
